import { MachineDescriptionStepComponent } from './description-step/description-step.component';
import { MachineDocumentsStepComponent } from './documents-step/documents-step.component';
import { MachineStepComponent } from './machine-step/machine-step.component';
import { MachineSchedulingStepComponent } from './scheduling-step/scheduling-step.component';

export const machineStepsComponents = [
  MachineDescriptionStepComponent,
  MachineDocumentsStepComponent,
  MachineStepComponent,
  MachineSchedulingStepComponent,
];
